<div class="detail-content-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
	<ng-container *ngIf="resourceDetail?.description">
		<div class="detail-content-header" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
			<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">

				<div class="descrip-block">
					<app-readability [length]="200" [canRead]="true">
						<content>
							{{resourceDetail?.description}}
						</content>
					</app-readability>
				</div>
			</div>
		</div>
	</ng-container>
	<div class="detail-content-body" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
		<div class="knowledge-card" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
			<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="28px" class="submission-block">
				<loader [loader]="loader" [type]="'general'"></loader>
				<div class="submission-title">{{locale.translate('knowledge_beads')}}</div>
				<div class="submission-content-area" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
					<ng-container *ngIf="!beadsData?.length && !loader">
						<ng-container *ngIf="resourceDetail?.createdBy === currentUser?.userID">
							<div fxLayout="row" fxLayoutAlign="start start">
								<div fxFlex="0 1 760px" fxFlex.xs="auto" class="no-data" fxLayout="row" fxLayoutAlign="center center">
									<p>
										{{locale.translate('no_knowledge_bead_yet')}}
									</p>
								</div>
							</div>
						</ng-container>
					</ng-container>
					<ng-container *ngIf="beadsData?.length">
						<div fxLayout="row" fxLayoutAlign="start start">
							<div fxFlex="0 1 760px" fxFlex.xs="auto" fxLayout="column" fxLayoutAlign="start stretch"
								fxLayoutGap="24px" class="content-image-card">
								<ng-container
									*ngFor="let bead of beadsData; let i = index; trackBy: gfService.trackByID.bind({'key': 'resourceID'})">
									<app-content-image-card [record]="bead" (profile)="searchPeopleDetail(bead)"
										(remove)="alertPopup('deleteBead',bead, {index:i, actionElement:$event.actionElement})"
										(detail)="detail($event)">
									</app-content-image-card>
								</ng-container>
								<ng-container
									*ngIf="['assigned', 'reassigned', 'overdue'].includes(status?.key) && resourceDetail?.resourceAction?.addBead">
									<p class="hyperlink" (click)="addBead()">{{locale.translate('add_new')}}</p>
								</ng-container>
							</div>
						</div>
					</ng-container>

					<ng-container
						*ngIf="!loader && ['assigned', 'reassigned', 'overdue'].includes(status?.key) && resourceDetail?.resourceAction?.addBead && !beadsData?.length">
						<div fxLayout="row" fxLayoutAlign="start start">
							<div fxFlex="1 1" fxFlex.xs="auto" fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="30px"
								fxLayout.xs="column" fxLayoutGap.xs="10px" class="button-block">
								<div class="knowledge-card-view" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px"
									fxLayoutGap.xs="10px">
									<div fxLayout="row" fxLayoutAlign="center center">
										<mat-icon class="knowledge-icon" svgIcon="knowledge_card"></mat-icon>
									</div>
									<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="15px" fxLayoutGap.xs="10px">
										<p class="knowledge-card-info">
											{{locale.translate('knowledge_card_is_an_instruction_to_contribute_desc')}}
										</p>
										<p class="knowledge-card-info">
											{{locale.translate('you_can_share_your_knowledge_desc')}}
										</p>
									</div>
									<div class="button-block" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
										<button mat-stroked-button class="add-btn" #actionBtn
											(click)="addBead(actionBtn)">{{locale.translate('add_knowledge_bead')}}</button>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
		</div>
		<div class="feature-placeholder fx-column fx-start-stretch"
			[ngStyle]="{'display': detectDevice?.resolutionState$?.value?.deviceType === 'mobile' ? 'block' : 'none'}">
		</div>
	</div>
</div>
<!-- <ng-container [ngTemplateOutlet]="feature"></ng-container> -->
